import store from '../store/index'

export default class TeamService {
    async getTeams() {
        const data = await store.dispatch('jv/get', 'teams');
        return Object.values(data)
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }
}
